import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { ToastService } from "@app/modules/shared/services/message/toast.service";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { ExplorerService } from "@app/modules/shared/services/explorer.service";
import { TreeView } from "@syncfusion/ej2-angular-navigations";
import * as _ from "lodash";
import { UtilService } from "@app/modules/shared/services/util.service";

@Component({
  selector: "kl-role-permission",
  templateUrl: "./role-permission.component.html",
  styleUrls: ["./role-permission.component.scss"],
})
export class RolePermissionComponent implements OnInit {
  @Input() tabId: string;
  @Input() entity: any;
  treeView: TreeView;

  permissionData = [
    {
      id: "01",
      text: this.translateService.instant("material_management"),
      children: [
        {
          id: "01.01",
          text: this.translateService.instant("definitions"),
          children: [
            {
              id: "01.01.01",
              text: this.translateService.instant("units"),
              children: [
                {
                  id: "01.01.01.001",
                  text: this.translateService.instant("add"),
                },
                {
                  id: "01.01.01.002",
                  text: this.translateService.instant("edit"),
                },
                {
                  id: "01.01.01.003",
                  text: this.translateService.instant("view"),
                },
                {
                  id: "01.01.01.004",
                  text: this.translateService.instant("delete"),
                },
                {
                  id: "01.01.01.005",
                  text: this.translateService.instant("entry_info"),
                },
              ],
            },
            {
              id: "01.01.02",
              text: this.translateService.instant("unit_sets"),
              children: [
                {
                  id: "01.01.02.001",
                  text: this.translateService.instant("add"),
                },
                {
                  id: "01.01.02.002",
                  text: this.translateService.instant("edit"),
                },
                {
                  id: "01.01.02.003",
                  text: this.translateService.instant("view"),
                },
                {
                  id: "01.01.02.004",
                  text: this.translateService.instant("delete"),
                },
                {
                  id: "01.01.02.005",
                  text: this.translateService.instant("entry_info"),
                },
              ],
            },
          ],
        },
        {
          id: "01.02",
          text: this.translateService.instant("cards"),
          children: [
            {
              id: "01.02.01",
              text: this.translateService.instant("materials"),
              children: [
                {
                  id: "01.02.01.001",
                  text: this.translateService.instant("add"),
                },
                {
                  id: "01.02.01.002",
                  text: this.translateService.instant("edit"),
                },
                {
                  id: "01.02.01.003",
                  text: this.translateService.instant("view"),
                },
                {
                  id: "01.02.01.004",
                  text: this.translateService.instant("delete"),
                },
                {
                  id: "01.02.01.005",
                  text: this.translateService.instant("entry_info"),
                },
                {
                  id: "01.02.01.006",
                  text: this.translateService.instant("copy"),
                },
              ],
            },
            {
              id: "01.02.02",
              text: this.translateService.instant("unit_sets"),
              children: [
                {
                  id: "01.02.02.001",
                  text: this.translateService.instant("add"),
                },
                {
                  id: "01.02.02.002",
                  text: this.translateService.instant("edit"),
                },
                {
                  id: "01.02.02.003",
                  text: this.translateService.instant("view"),
                },
                {
                  id: "01.02.02.004",
                  text: this.translateService.instant("delete"),
                },
                {
                  id: "01.02.02.005",
                  text: this.translateService.instant("entry_info"),
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "02",
      text: this.translateService.instant("finance_management"),
      children: [
        {
          id: "02.01",
          text: this.translateService.instant("cards"),
          children: [
            {
              id: "02.01.01",
              text: this.translateService.instant("current_accounts"),
              children: [
                {
                  id: "02.01.01.001",
                  text: this.translateService.instant("add"),
                },
                {
                  id: "02.01.01.002",
                  text: this.translateService.instant("edit"),
                },
                {
                  id: "02.01.01.003",
                  text: this.translateService.instant("view"),
                },
                {
                  id: "02.01.01.004",
                  text: this.translateService.instant("delete"),
                },
                {
                  id: "02.01.01.005",
                  text: this.translateService.instant("entry_info"),
                },
                {
                  id: "02.01.01.006",
                  text: this.translateService.instant("copy"),
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "03",
      text: this.translateService.instant("virtual_shipping_management"),
      children: [
        {
          id: "03.01",
          text: this.translateService.instant("cards"),
          children: [
            {
              id: "03.01.01",
              text: this.translateService.instant("customers"),
              children: [
                {
                  id: "03.01.01.001",
                  text: this.translateService.instant("add"),
                },
                {
                  id: "03.01.01.002",
                  text: this.translateService.instant("edit"),
                },
                {
                  id: "03.01.01.003",
                  text: this.translateService.instant("view"),
                },
                {
                  id: "03.01.01.004",
                  text: this.translateService.instant("delete"),
                },
                {
                  id: "03.01.01.005",
                  text: this.translateService.instant("entry_info"),
                },
                {
                  id: "03.01.01.006",
                  text: this.translateService.instant("copy"),
                },
              ],
            },
          ],
        },
        {
          id: "03.02",
          text: this.translateService.instant("movements"),
          children: [
            {
              id: "03.02.01",
              text: this.translateService.instant("virtual_order_receipts"),
              children: [
                {
                  id: "03.02.01.001",
                  text: this.translateService.instant("add"),
                },
                {
                  id: "03.02.01.002",
                  text: this.translateService.instant("edit"),
                },
                {
                  id: "03.02.01.003",
                  text: this.translateService.instant("view"),
                },
                {
                  id: "03.02.01.004",
                  text: this.translateService.instant("delete"),
                },
                {
                  id: "03.02.01.005",
                  text: this.translateService.instant("entry_info"),
                },
                {
                  id: "03.02.01.006",
                  text: this.translateService.instant("approve"),
                },
                {
                  id: "03.02.01.007",
                  text: this.translateService.instant("generate_license_key"),
                },
                {
                  id: "03.02.01.008",
                  text: this.translateService.instant("print"),
                },
                {
                  id: "03.02.01.009",
                  text: this.translateService.instant("copy"),
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "04",
      text: this.translateService.instant("other_operations"),
      children: [
        {
          id: "04.01",
          text: this.translateService.instant(
            "kl_retail_mpos_emq_get_password"
          ),
          children: [
            {
              id: "04.01.001",
              text: this.translateService.instant("generate_password"),
            },
          ],
        },
      ],
    },
  ];
  public fields = {
    dataSource: this.permissionData,
    id: "id",
    text: "text",
    child: "children",
  };
  flattenNodes: Array<{
    auth_number: string;
    description: string;
    is_authorized: string;
    role: {
      id: number;
    };
  }>;
  show = false;
  alertMessage = "";
  alertShow = false;

  constructor(
    private apiService: ApiService,
    private explorerService: ExplorerService,
    private klLoadingService: KlLoadingService,
    private utilService: UtilService,
    private translateService: TranslateService,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    this.flattenNodes = [];
    this.klLoadingService.show("loading");
    this.apiService
      .getDataById("user-role-permission/getbyrole", this.entity.id)
      .subscribe(
        (response) => {
          if (response === undefined) {
            this.handleError("error_data");
          } else {
            const checkedNodes = [];
            if (response.length > 0) {
              for (let i = 0; i < response.length; i++) {
                if (response[i].is_authorized === "YES") {
                  checkedNodes.push(response[i].auth_number);
                }
                if (i === response.length - 1) {
                  this.klLoadingService.hide();
                }
              }
            } else {
              this.klLoadingService.hide();
            }
            this.treeView = new TreeView({
              fields: this.fields,
              showCheckBox: true,
              autoCheck: false,
              checkedNodes: checkedNodes,
            });
            this.treeView.appendTo("#permissionTreeView");
          }
        },
        () => {
          this.klLoadingService.hide();
        }
      );
  }

  selectAll() {
    this.treeView.checkAll();
    this.treeView.expandAll();
  }

  unSelectAll() {
    this.treeView.uncheckAll();
  }

  save() {
    this.klLoadingService.show("saving");
    this.flattenObjectArray(this.treeView.getTreeData());
    this.apiService
      .addData("user-role-permission", this.flattenNodes)
      .subscribe(
        () => {
          this.toastService.toastSuccess();
          this.klLoadingService.hide();
          if (this.tabId) {
            this.explorerService.closeTab(this.tabId);
          }
        },
        () => {
          this.klLoadingService.hide();
        }
      );
  }

  flattenObjectArray(item: any) {
    if (_.isArray(item)) {
      item.map((it) => {
        return this.flattenObjectArray(it);
      });
    } else {
      if (item.hasOwnProperty("children")) {
        this.flattenNodes.push({
          auth_number: item.id,
          description: item.text,
          is_authorized: item.isChecked ? "YES" : "NO",
          role: {
            id: this.entity.id,
          },
        });
        return this.flattenObjectArray(item.children);
      } else {
        this.flattenNodes.push({
          auth_number: item.id,
          description: item.text,
          is_authorized: item.isChecked ? "YES" : "NO",
          role: {
            id: this.entity.id,
          },
        });
      }
    }
  }

  handleError(error: any) {
    this.alertShow = true;
    this.alertMessage = this.utilService.alertErrorMessage(error);
    this.klLoadingService.hide();
  }
}
